// src/components/RegisterSkeleton.tsx
// Lade-Fallback für /register (während die Register-Seite nachlädt). Markup und
// CSS (#register-static in index.html) sind identisch mit dem statischen
// Startinhalt aus dem HTML, damit beim Wechsel keine Headline verschwindet.
const headlineTiming = { elementtiming: "register-headline" } as Record<string, string>;

/** Wie Register.tsx: Kommt der Nutzer aus dem Schnell-Check (next=/check), anderer Text. */
function istCheckVariante(): boolean {
  if (typeof window === "undefined") return false;
  return new URLSearchParams(window.location.search).get("next") === "/check";
}

export function RegisterSkeleton() {
  return (
    <div id="register-static">
      <a href="https://www.propora.de" className="rs-logo">
        <img src="/assets/propora-logo-transparent.png" alt="PROPORA" />
      </a>
      {istCheckVariante() ? (
        <div className="rs-head">
          <h1 {...headlineTiming}>
            Fast geschafft.
            <br />
            <span>Dein Ergebnis wartet.</span>
          </h1>
          <p>Registriere dich kostenlos: Du siehst, warum dein Score so ist, deinen wichtigsten Hebel und die Schuldendeckung. Dein Objekt wird dabei automatisch gespeichert.</p>
        </div>
      ) : (
        <div className="rs-head">
          <h1 {...headlineTiming}>
            Lohnt sich die Immobilie?
            <br />
            <span>In 60 Sekunden weißt du es.</span>
          </h1>
          <p>Kaufpreis, Miete, Finanzierung eingeben – Deal-Score, Urteil und der wichtigste Hebel.</p>
        </div>
      )}
      <div className="rs-gap" />
      <div className="rs-card" aria-hidden="true" />
    </div>
  );
}
